"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ORIENTATIONS = void 0;
var ORIENTATIONS = {
  X: 'x-axis',
  Y: 'y-axis',
  CENTER: 'center'
};
exports.ORIENTATIONS = ORIENTATIONS;